import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Actions
import { getMyOrders } from '../../../actions/mypage'
import { moveOrder } from '../../../actions/orders'
import { triggerPopup } from '../../../actions/backdrop'

// Utils
import { translation } from '../../../utils/helpers'
import EventEmitter from '../../../utils/events'

// Components
import Item from '../../NewWorkscreen/Item'
import QualityCheckModal from '../../../shared/modals/QualityCheckModal'
import { hasSubscriptionPermission } from '../../../utils/auth'

// Elements
import Col from '../../../shared/elements/col'
// import Panel from '../../../shared/elements/panel'
import Icon from '../../../shared/elements/icon'
import Grid from '../../../shared/elements/grid'
import PanelHeader from '../../../shared/elements/panelHeader'
import { ElementIcons } from '../../../shared/elements/icons'

class MyOrders extends Component {

  constructor (props) {
    super(props)
    this.state = {
      CurrentOrders: [],
      FutureOrders: [],
      quality: {
        open: false,
        data: {},
        index: 0,
        pos: 0,
        move: true
      }
    }
    this.getOrders = this.getOrders.bind(this)
    this.renderOrder = this.renderOrder.bind(this)
    this.completeOrder = this.completeOrder.bind(this)
    this.startOrderSuccess = this.startOrderSuccess.bind(this)
    this.closeQualityModal = this.closeQualityModal.bind(this)
    this.updateFromOrderSocket = this.updateFromOrderSocket.bind(this)
  }

  componentDidMount () {
    this.getOrders()
    EventEmitter.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this)
  }

  componentWillUnmount () {
    EventEmitter.removeListener('ORDER_SOCKET', this.updateFromOrderSocket)
  }

  updateFromOrderSocket (json) {
    if (json.Type === 'ORDER_MOVED' || json.Type === 'ORDER_STOPPED') this.getOrders()
  }

  getOrders () {
    this.props.getMyOrders(0).then((res) => {
      this.setState({
        CurrentOrders: res.data.CurrentOrders,
        FutureOrders: res.data.FutureOrders
      })
    }, () => {
      window.toastr.error(translation('1910'), translation('216'))
    })
  }

  completeOrder (id, fromStep, toStep, step, index, item) {
    let moveData = {
      OrderId: id,
      UserId: 0,
      StepFrom: item.StepId,
      StepTo: item.StepId + 1,
      Comment: '',
      FilterSettings: {},
      DontReturnOrders: true
    }
    this.props.moveOrder(moveData).then((res) => {
      this.setState({
        CurrentOrders: [],
        FutureOrders: []
      }, () => {
        this.getOrders()
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('1731'), translation('216'))
    })
  }

  startOrderSuccess () {
    this.closeQualityModal()
    this.props.getPunchClockStats()
  }

  renderOrder (val, key, isFutureOrder = false) {
    let className = ''
    // Visited
    if (typeof this.props.params.orderID !== 'undefined') {
      if (val.Id === parseInt(this.props.params.orderID)) {
        className += ' visited'
      }
    }

    return (
      <div key={key} className={'order__item__myorders ' + className}>
        <Grid cols={['minmax(0, 1fr)', 'min-content']} align='center'>
          <Item router={this.props.router} noCircle={isFutureOrder} type='1' item={val} key={key} index={key} step={0} MoveOrders={this.moveOrders.bind(this)} completeOrder={this.completeOrder} startOrderSuccess={this.startOrderSuccess} />
          <Link to={'/mypage/orders/' + val.Id}>
            <Icon icon={ElementIcons.Chevron_Right} />
          </Link>
        </Grid>
      </div>
    )
  }

  stepHasComments (data) {
    let ProcessComments = data.ProcessComments
    let anyComments = false
    if (ProcessComments) {
      ProcessComments.map((val) => {
        if (val.StepComments.length !== 0) anyComments = true
      })
    } else if (data.Checks) {
      data.Checks.map((check) => {
        check.ProcessComments.map((val) => {
          if (val.StepComments.length !== 0) anyComments = true
        })
      })
    }

    return anyComments
  }
  moveOrders (data) {
    if (data === undefined) {
      data = {
        OrderIds: this.state.MoveOrders.MoveAll === true ? this.state.MoveOrders.OrderIds : [this.state.MoveOrders.Id],
        UserId: 0,
        StepFrom: this.state.MoveOrders.FromStep,
        StepTo: this.state.MoveOrders.ToStep,
        Comment: '',
        FilterSettings: {}
      }
    }

    let orders = []
    for (let i = 0; i < data.OrderIds.length; i++) {
      let order = {
        OrderId: data.OrderIds[i]
      }
      orders.push(order)
    }

    let moveData = {
      Orders: orders,
      UserId: data.UserId,
      StepFrom: data.StepFrom,
      StepTo: data.StepTo,
      Comment: data.Comment,
      FilterSettings: data.FilterSettings,
      MoveAll: data.MoveAll,
      CheckOnly: false
    }

    this.props.moveOrder(moveData).then((res) => {
      if (res.data.MoveAll) {
        this.setState({
          MoveOrders: {
            ...this.state.MoveOrders,
            open: true,
            MoveAll: null,
            OrderIds: res.data.OrderIds,
            FromStep: data.StepFrom,
            ToStep: data.StepTo,
            Id: data.OrderIds[0]
          }
        }, () => {
          return null
        })
      } else if (res.data.Checks.length > 0) {
        this.props.triggerPopup(true)
        res.data.OrderIds = data.OrderIds
        this.setState({
          quality: {
            open: true,
            data: [res.data],
            pos: data.Pos,
            index: data.Index,
            move: true
          },
          MoveOrders: {
            ...this.state.MoveOrders,
            FromStep: moveData.StepFrom
          }
        })
      } else {
        if (this.stepHasComments(res.data)) {
          this.props.triggerPopup(true)
          this.setState({
            quality: {
              open: true,
              data: [res.data],
              pos: data.Pos,
              index: data.Index,
              move: true
            }
          })
        }
        //  else {
        // }
        // this.updateRow(res.data.CurrentStepOrders, data.Pos, data.Index)
        // let message = orders.length > 1 ? translation('12338') : translation('1909')
        // window.toastr.success(message, translation('13424'))
      }
    }, (res) => {
      // Toastr
      let message
      if (res.response.data.IsStopped === true) message = translation('12347')
      else if (res.response.data.IsReffered === true) message = translation('2704')
      else message = orders.length > 1 ? translation('12339') : translation('1731')
      window.toastr.error(message, translation('216'))
    })
  }
  renderCurrentOrders () {
    return (
      <div className='clearfix'>
        {this.state.CurrentOrders.length === 0 && (
          <div>{translation('1890')}</div>
        )}
        {this.state.CurrentOrders.map(this.renderOrder)}
      </div>
    )
  }

  renderFutureOrders () {
    let comingOrders = this.state.FutureOrders.filter(item => !this.state.CurrentOrders.some(x => x.Id === item.Id))
    return (
      <div className='clearfix'>
        {comingOrders.length === 0 && (
          <div>{translation('1890')}</div>
        )}
        {comingOrders.map((val, key) => this.renderOrder(val, key, true))}
      </div>
    )
  }

  renderChild () {
    let child = ''
    if (this.props.children !== null) {
      child = React.cloneElement(this.props.children, {
      })
    }
    return child
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return (
      <div>
        <Col id='items'>
          {this.props.renderMenu()}
          <PanelHeader text={translation('1888')} />
          {this.renderCurrentOrders()}
          <PanelHeader text={translation('586')} />
          {this.renderFutureOrders()}
        </Col>
        <Col id='order'>
          {this.renderChild()}
        </Col>
        {this.state.quality.open && (
          <QualityCheckModal
            router={this.props.router}
            show={this.state.quality.open}
            data={this.state.quality.data}
            onMoveSuccess={this.moveOrderSuccess.bind(this)}
            onClose={this.closeQualityModal.bind(this)}
            move={this.state.quality.move} />
        )}
      </div>
    )
  }

  moveOrderSuccess (data) {
    this.closeQualityModal()
  }
  closeQualityModal () {
    this.props.triggerPopup(false)
    this.setState({
      quality: {
        open: false,
        data: {},
        index: 0,
        pos: 0
      }
    }, () => {
      this.getOrders()
    })
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getMyOrders,
  moveOrder,
  triggerPopup
})(MyOrders)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyOrders/index.js